import { colorStrings } from "@iewcasia/Utilities/variables";
import { compactHeaderStyles as styles } from "@insite/content-library/Pages/CompactHeader";
import { getProp } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

styles.page = {
    ...styles.page,
    css: css`
        ${styles.page?.css};

        ${({ theme }) => {
            const {
                header: { linkColor },
            } = theme;
            return css`
                color: ${getColor(linkColor)};

                &&&& [data-test-selector="cartLink"] svg {
                    color: ${getColor(linkColor)};
                }
            `;
        }}

        z-index: ${getProp("theme.zIndex.toaster")};
    `,
};

styles.logoWrapper = {
    ...styles.logoWrapper,
    css: css`
        & > div {
            display: flex;
            min-width: 100px;
            justify-content: flex-start;
            align-items: center;
            gap: 1px;
            border: 5px solid transparent;
            height: 50px;
            z-index: 10;

            div {
                display: flex;
                align-items: center;
                height: 40px;
                flex: 1 1 auto;
                justify-content: center;
                max-width: 80px;

                &:empty {
                    display: none;
                }
            }

            a {
                display: flex;
                height: 100%;
                align-items: center;

                span {
                    height: 100%;
                }
            }

            div:has(.img) + div:has(.img) {
                border-left: 2px solid ${getColor(colorStrings.commonGlobalGray03)};
                padding-inline-start: 5px;
                margin-inline-start: 5px;
            }
        }

        img {
            width: auto;
            height: 100%;
            aspect-ratio: 4/3;
            object-fit: contain;
            min-width: 70px !important;
        }
    `,
};

styles.mainNavigationWrapper = {
    ...styles.mainNavigationWrapper,
    css: css`
        ${styles.mainNavigationWrapper?.css};
        justify-content: flex-start;
    `,
};
